import React from 'react';
import axios from 'axios';
import Select from 'react-select';
import './form.css';
import { AddRevenue } from '../../Redux/action/revenueAction';
import { allLocationWithShortName, dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import { toast } from 'react-toastify';
import SwInput from '../Common/FormComponent/SwInput';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";


const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName();
let count = 0;

class SpaceRequire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '',
      location1: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      startDate: '',
      endDate: '',
      purpose: '',
      decorationBudget: '',
      foodBudget: '',
      giftingBudget: '',
      notes: '',
      locationError: '',
      startDateError: '',
      endDateError: '',
      modal: false,
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    };
  }


  changeSelect = (e) => {
    if (!e) {
      this.setState({
        location: null,
        location1: "",
        locationId: "",
        locationError: "",
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: "",
    });
  };

  componentDidMount() {
    const LocationSpoc = JSON.parse(userDataLocal12);
    const locationShort = JSON.parse(locationWithShortName);
    this.setState({ locationNew: locationShort, locationData: LocationSpoc });
  }

  onNotes = e => {
    this.setState({ notes: e.target.value });
  };


  handlePurposeOfEvent = (selectedPurpose) => {

    this.setState({ purpose: selectedPurpose, purposeError: '' })
  }

  onEndDateChange = e => {
    const endDate = e.target.value;
    const { startDate } = this.state;

    if (!startDate) {
      // If start date is not selected
      this.setState({ endDateError: '' }); // Clear existing end date error
      toast.error("Please select start date before selecting end date.");
    } else if (new Date(endDate) < new Date(startDate)) {
      // If end date is before start date
      this.setState({ endDateError: "End Date cannot be before Start Date" });
      toast.error("End Date cannot be before Start Date");
    } else {
      // If valid end date
      this.setState({
        endDate: endDate,
        endDateError: '',
      });
    }
  };

  resetValue = () => {
    this.setState({
      location: '',
      startDate: '',
      location1: '',
      endDate: '',
      notes: '',
      purpose: '',
      startDateError: '',
      endDateError: '',
      locationError: '',
      attachmentError: '',
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    });
  };

  options1 = [
    { value: 'hiring_drive', label: 'Hiring drive' },
    { value: 'official_function', label: 'Official function' },
    { value: 'celebration', label: 'Celebration' },
    { value: 'town_hall', label: 'Town Hall' },
    { value: 'training_sessions', label: 'Training Session' },
    { value: 'other', label: 'Other' }
  ];

  handleFile = e => {
    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
        files: e.target.files
      });
    }
    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else {
      this.setState({ attachmentError: "" });
    }
  };


  handleSubmit = e => {
    e.preventDefault();
    const { startDate, endDate, purpose, location1, files, decorationBudget, foodBudget, giftingBudget, notes } = this.state;

    let formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }

    // Clear previous errors
    this.setState({
      locationError: '',
      startDateError: '',
      endDateError: '',
      purposeError: '',
      attachmentError: '',
    });

    let hasError = false;

    // Validation checks
    if (!location1) {
      this.setState({ locationError: "Location can't be empty" });
      hasError = true;
    } else if (!startDate) {
      this.setState({ startDateError: "Start Date can't be empty" });
      hasError = true;
    } else if (!endDate) {
      this.setState({ endDateError: "End Date can't be empty" });
      hasError = true;
    } else if (new Date(endDate) < new Date(startDate)) {
      this.setState({ endDateError: "End Date cannot be earlier than Start Date" });
      hasError = true;
    } else if (!purpose) {
      this.setState({ purposeError: "Purpose can't be empty" });
      hasError = true;
    } else if (files && files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
      hasError = true;
    }

    if (hasError) return;

    e.currentTarget.disabled = true;

    const param = {
      common_param: {
        company_id: UserObj ? UserObj.company_id : null,
        spoc_id: UserObj ? UserObj.rec_id : null,
        email: UserObj ? UserObj.email : null,
        category: 'catering_decoration',
        company_name: UserObj ? UserObj.company_name : null
      },
      body_param: {
        location_name: location1,
        start_date: startDate,
        end_date: endDate,
        event_purpose: purpose.value,
        decoration_budget: decorationBudget,
        food_budget: foodBudget,
        gifting_budget: giftingBudget,
        notes: notes,
      }
    };

    // AddRevenue(param, formData)


    // this.resetValue()
    // this.setState({
    //   btnStatus: false,
    // });
    // e.currentTarget.disabled = false

    AddRevenue(param, (success, message) => {
      if (success) {
        toast.success(message);
        this.resetValue();
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
      this.setState({ btnStatus: false });
      e.currentTarget.disabled = false;
    });
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>Location <span className="Required">*</span></label>
              <SwSelect
                name="location"
                id="catering-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
              />
              <span className="SwTextDanger SwTextSmall">  {this.state.locationError}</span>
            </div>
          </div>
        </div>


        <div className="row">
          {/* START DATE */}
          <div className="col-md-6 ">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                Start Date <span className="Required">*</span>
              </label>

              <AntDDatePicker
                value={this.state.startDate ? dayjs(this.state.startDate) : null}
                onChange={(date) =>
                  this.setState({
                    startDate: date ? date.format("YYYY-MM-DD") : "",
                    startDateError: "",
                    endDate: "", // reset end date if start changes
                    endDateError: "",
                  })
                }
                // allowClear={false}
                placeholder="Start Date"
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
              />

              <span className="SwTextDanger SwTextSmall">{this.state.startDateError}</span>
            </div>
          </div>

          {/* END DATE */}
          <div className="col-md-6">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                End Date <span className="Required">*</span>
              </label>

              <AntDDatePicker
                value={this.state.endDate ? dayjs(this.state.endDate) : null}
                onChange={(date) => {
                  if (!this.state.startDate) {
                    this.setState({ endDateError: "Please select start date first" });
                    return;
                  }

                  const endDate = date ? date.format("YYYY-MM-DD") : "";

                  if (endDate < this.state.startDate) {
                    this.setState({
                      endDateError: "End date cannot be before start date",
                    });
                    return;
                  }

                  this.setState({
                    endDate,
                    endDateError: "",
                  });
                }}
                allowClear={false}
                placeholder="End Date"
                disabled={!this.state.startDate}
                disabledDate={(current) =>
                  this.state.startDate &&
                  current &&
                  current < dayjs(this.state.startDate)
                }
              />

              <span className="SwTextDanger SwTextSmall">{this.state.endDateError}</span>
            </div>
          </div>
        </div>


        <div className="row">
          <div className="col-md-6">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>Purpose Of Event <span className="Required">*</span></label>
              <SwSelect
                id="catering-event-select"
                placeholder="Select"
                options={this.options1}
                value={this.state.purpose}
                onChange={this.handlePurposeOfEvent}
              />
              <span className="SwTextDanger SwTextSmall"> {this.state.purposeError}</span>
            </div>
          </div>



          <div className="col-md-6">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>Decoration Budget (Total)</label>
              <SwInput
                id="catering-decoartion-budget-input"
                type="number"
                min="0"
                onChange={e => this.setState({ decorationBudget: e.target.value })}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 ">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>Food Budget (Total)</label>
              <SwInput
                id="catering-food-budget-input"
                type="number"
                min="0"
                onChange={e => this.setState({ foodBudget: e.target.value })}
              />
            </div>
          </div>

          <div className="col-md-6 ">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>Gifting Budget (Total)</label>
              <SwInput
                id="catering-gift-budget-input"
                type="number"
                min="0"
                onChange={e => this.setState({ giftingBudget: e.target.value })}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 ">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>Notes</label>
              <SwTextArea
                rows="4"
                id="catering-notes"
                value={this.state.notes}
                onChange={this.onNotes}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SpaceRequire;